import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch
} from 'react-router-dom'
import { lazy, Suspense } from 'react'

import RoutesRedirect from './RoutesRedirect'
import { ROUTER_BASE_PATH } from 'configs/routerBasePath'
import Spinner from 'components/Spinner'
import useRoutePerformance from 'hooks/useRoutePerformance'

const App = lazy(() => import('./App/App'))
const Auth = lazy(() => import('./Auth/Auth'))
const Service = lazy(() => import('./Service/Service'))

const RoutePerformanceTracker = () => {
  useRoutePerformance()
  return null
}

const Navigator = () => {
  return (
    <Router basename={ROUTER_BASE_PATH}>
      <RoutesRedirect>
        <RoutePerformanceTracker />
        <Suspense fallback={<Spinner height="100vh" />}>
          <Switch>
            <Route path="/" exact>
              <Redirect to="/auth" />
            </Route>
            <Route path="/auth/:path?" component={Auth} />
            <Route path="/service/:path?" component={Service} />
            <Route component={App} />
          </Switch>
        </Suspense>
      </RoutesRedirect>
    </Router>
  )
}

export default Navigator
